import { render, staticRenderFns } from "./AuthorsPage.vue?vue&type=template&id=2a5b8c92"
import script from "./AuthorsPage.vue?vue&type=script&lang=js"
export * from "./AuthorsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports